<template>
    <EditPlanForm
        :plan-id="planId"
        layout="page"
        @success="onSuccess"
        @cancel="goBack"
    />
</template>

<script>
    import EditPlanForm from '@/components/Weflix/Payment/EditPlanForm.vue';

    export default {
        components: {
            EditPlanForm,
        },
        computed: {
            planId() {
                return String(this.$route.params.slug || '');
            },
        },
        methods: {
            onSuccess() {
                this.$router.push('/admin/pagamentos');
            },
            goBack() {
                this.$router.push('/admin/pagamentos');
            },
        },
    };
</script>
